import axios from "axios";

const axiosApi = axios.create();

export default axiosApi;
